import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import { IoIosArrowBack } from "react-icons/io";
import { EditIconButton } from "../../../main/components/EditIconButton";
import { Client } from "../types";
import { EditTextInfoModal } from "../../../main/components/EditTextInfoModal";
import * as yup from "yup";
import { clientsApi } from "../../../services/api";
import { MainContext } from "../../../main/context/MainContextProvider";

const nameSchema = yup.object().shape({
  name: yup.string().required("Nome do cliente é obrigatório"),
});
export function ClientDetailsHeader(props: {
  client: Client | null;
  setClient: (client: Client | null) => void;
  onMount: () => void;
}) {
  const { userIsAdm, userIsClient } = useContext(MainContext);
  const { client, setClient, onMount } = props;
  const navigate = useNavigate();
  const [showEditNameModal, setShowEditNameModal] = useState<boolean>(false);
  const [newName, setNewName] = useState<string>("");

  const confirmNameChange = async () => {
    if (client) {
      await clientsApi.pathClientDetails(client?.id, { name: newName });
      const updatedClient = await clientsApi.getClient(client?.id);
      setClient(updatedClient);
    }
  };
  const update = () => {
    setNewName(client?.name ?? "");
  };
  useEffect(() => {
    update();
  }, [client]);
  return (
    <>
      <Grid
        container
        display={{ xs: "flex" }}
        width="80%"
        paddingBottom={"20px"}
        alignItems={"center"}
        marginLeft="-17px"
      >
        <Grid item xs={1} sm={0.5}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <IconButton
              onClick={() => {
                navigate("/clients/");
              }}
              sx={{
                width: {
                  xs: "35px",
                  sm: "40px",
                },
                height: {
                  xs: "35px",
                  sm: "40px",
                },
              }}
            >
              <IoIosArrowBack />
            </IconButton>
          </Box>
        </Grid>
        <Grid
          display={"flex"}
          item
          xs={11}
          sm={4}
          alignItems={"center"}
          sx={{
            paddingLeft: { xs: "10px", md: "" },
          }}
        >
          <Typography
            sx={{
              marginRight: "10px",
              fontWeight: 500,
              fontSize: {
                xs: "18px",
                sm: "24px",
              },
            }}
          >
            {/* {mockClients[0].clientFounded.name} */}
            {client?.name}
          </Typography>
          {(userIsAdm || userIsClient) && (
            <EditIconButton
              onClick={() => {
                setShowEditNameModal(true);
              }}
              tooltipText="Editar Nome do Cliente"
            />
          )}
        </Grid>
      </Grid>

      <EditTextInfoModal
        open={showEditNameModal}
        setOpen={setShowEditNameModal}
        label={"Nome"}
        title={"Alterar Nome"}
        fieldName={"name"}
        newInfo={newName}
        setNewInfo={setNewName}
        schema={nameSchema}
        onConfirm={confirmNameChange}
        confirmationModalTitle={"Alterar nome"}
        confirmationModalContentText={"Deseja confirmar a alteração do nome?"}
        successModalTitle={"Nome alterado com sucesso"}
        successModalContentText={"O nome foi alterado com sucesso!"}
        errorModalTitle={"Erro ao alterar nome"}
        errorModalContentText={
          "Ocorreu um erro ao alterar o nome, tente novamente mais tarde."
        }
        onMount={onMount}
      />
    </>
  );
}
